import { Link } from "react-router-dom";

/**
 * Brand mark from /public/logo192.png & logo512.png
 */
export const BrandLogo = ({
  to = "/",
  size = "md",
  showWordmark = true,
  className = "",
}) => {
  const sizes = {
    sm: { box: "h-9 w-9", img: "h-7 w-7", title: "text-lg", sub: "text-[9px]" },
    md: {
      box: "h-11 w-11",
      img: "h-8 w-8",
      title: "text-lg sm:text-2xl",
      sub: "text-[10px]",
    },
    lg: { box: "h-14 w-14", img: "h-11 w-11", title: "text-2xl", sub: "text-xs" },
  };
  const s = sizes[size] || sizes.md;

  return (
    <Link
      to={to}
      className={`flex min-w-0 items-center gap-2.5 group shrink-0 ${className}`}
    >
      <div
        className={`relative flex ${s.box} items-center justify-center overflow-hidden rounded-xl bg-slate-950 shadow-lg shadow-primary-600/25 ring-1 ring-primary-500/30 transition-transform duration-300 group-hover:scale-105`}
      >
        <img
          src="/logo512.png"
          alt="OOMS logo"
          width={56}
          height={56}
          className={`${s.img} object-contain`}
          decoding="async"
        />
      </div>
      {showWordmark && (
        <div className="flex min-w-0 flex-col">
          <span
            className={`font-heading font-black ${s.title} leading-none tracking-tight text-foreground transition-colors group-hover:text-primary-600 truncate max-w-[110px] sm:max-w-none`}
          >
            OOMS
          </span>
          <span
            className={`${s.sub} font-bold uppercase tracking-[0.16em] text-text-sub mt-0.5 truncate max-w-[110px] sm:max-w-none`}
          >
            OneSaaS Cloud
          </span>
        </div>
      )}
    </Link>
  );
};

export default BrandLogo;
